// extracted by mini-css-extract-plugin
export default {"facts__highlight":"CESODc6","facts__subline":"UQamy5F"};